
export default (urlParameters) => {
  return {}
}